"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiAlertDialogWrapper = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var internal_1 = require("../../../internal");
var useBrokenAlertFiltersMeta_1 = require("./useBrokenAlertFiltersMeta");
var KpiAlertDialogWrapperCore = function (props) {
    var brokenAlertFiltersBasicInfo = props.brokenAlertFiltersBasicInfo, backend = props.backend, workspace = props.workspace, intl = props.intl, restProps = tslib_1.__rest(props, ["brokenAlertFiltersBasicInfo", "backend", "workspace", "intl"]);
    var _a = useBrokenAlertFiltersMeta_1.useBrokenAlertFiltersMeta({
        backend: backend,
        workspace: workspace,
        brokenAlertFilters: brokenAlertFiltersBasicInfo,
    }), brokenAlertFiltersMeta = _a.result, status = _a.status;
    var brokenAlertFilters = react_1.useMemo(function () {
        if (!brokenAlertFiltersMeta) {
            return null;
        }
        return internal_1.enrichBrokenAlertsInfo(brokenAlertFiltersBasicInfo, intl, restProps.dateFormat, brokenAlertFiltersMeta.dateDatasets, brokenAlertFiltersMeta.attributeFiltersMeta);
    }, [brokenAlertFiltersMeta, restProps.dateFormat]);
    return (react_1.default.createElement(internal_1.KpiAlertDialog, tslib_1.__assign({}, restProps, { isAlertDialogOpening: status === "loading", brokenAlertFilters: brokenAlertFilters })));
};
exports.KpiAlertDialogWrapper = react_intl_1.injectIntl(KpiAlertDialogWrapperCore);
//# sourceMappingURL=KpiAlertDialogWrapper.js.map